import JSEncrypt from 'jsencrypt'

const pubKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjI6Cwi53bmXCYZZdlNNmm3I1NcLuGehdknaSW8ddPQ9eTUfEwHw4UrtT6m1i2SYm0c605DU7vQoIJ/AqodbOzGKFq3BHRZuGiHdRmmbSZyxxFwsgq0WZVm6J6tyKyVjdt6d09krjlp89rk6u2Y3cZDkdRjSKv7fly+SQl3dHIWEElYsgMdMuPnW6BaUxXTlH4U1XBcJ3tHSwmMv9fB8RUSMzNu18R2hQXN1Vji7/uWSoETg2OcHc43i9xkN7JNlmMiEzuahqeQTnBhygi4YHU5Oe0QV8fK98kgbW71jKoMg9naLAPPSYCtcheYofPJdUqpVNEi2llw+VyzitzfRm4QIDAQAB`

export const encrypt = str => {
  const encryptor = new JSEncrypt() // 创建加密对象实例
  encryptor.setPublicKey(pubKey) //设置公钥
  const cryptStr = encryptor.encrypt(str)
  return base64ToHex(cryptStr)
}

function base64ToHex(str) {
  const hex = []
  const bin = window.atob(str.replace(/[ \r\n]+$/, ''))
  for (let i = 0; i < bin.length; ++i) {
    let tmp = bin.charCodeAt(i).toString(16)
    if (tmp.length === 1) tmp = '0' + tmp
    hex[hex.length] = tmp
  }
  return hex.join('')
}



// WEBPACK FOOTER //
// ./src/lib/encryptor.js